/* eslint-disable @typescript-eslint/no-explicit-any */
import InitialsBubble from "features/settings/manage-users/components/initials-bubble";
import { useSelector } from "react-redux";
import EditModeSwitch from "shared/components/edit-mode-switch";
import { SwitchProvider } from "shared/dynamic-imports";
import { Button, IconDispatcher } from "shared/ui-basics/index";
import styled from "styled-components";
import GenericTypeahead from "../GenericTypeahead";
import { EMPTY_GUID } from "utils/helpers";

const OwnerItem = ({ user, isEdit, handleRemove }: any) => {
    const onRemove = (e: any) => {
        e.stopPropagation();
        handleRemove(user.id);
    }
    return <Card >
        <InitialsBubble fullName={user?.fullName} size="sm" />
        <OwnerName>{user?.fullName}</OwnerName>
        {isEdit && handleRemove && (
            <div>
                <Button
                    variant="light-link"
                    className="remove-button"
                    isicon="true"
                    size="xs"
                    iconClassName="ms-1"
                    onClick={onRemove} >
                    {IconDispatcher("X")}
                </Button>
            </div>
        )}
    </Card>
}
type Props = {
    object: any;
    link: (id: string) => void;
    unlink: (id: string) => void;
    disableViewer: boolean;
    minHeight?: string;
    isSwitchDisabled?: boolean;
    attributeName?: string;
}
export default function OwnerDropdown({ object, link, unlink,attributeName, disableViewer, isSwitchDisabled }: Props) {


    const authorizedUsers = useSelector((state: any) => state.settings.currentWorkspaceAuthorizedUsers);
    const selectedOwner = GetSelectedOwner(object, authorizedUsers,attributeName);
    const renderReadOnlyItems = () => (
        <>
            {selectedOwner?.map((user: any) => (
                <div key={user?.id}>
                    <OwnerItem user={user} />
                </div>
            ))}
        </>
    );

    const params = {
        selected: selectedOwner,
        options: authorizedUsers,
        renderSelectedItem: (item: any) => <OwnerItem key={item?.id} user={item} isEdit={true} handleRemove={unlink} />,
        renderMenuItem: ({ item }: any) => <OwnerItem user={item} />,
        linkMenuItem: ({ item,close }: any) => {
            link(item.id)
            close();
        },
        filter: ({ query, option }: any) => {
            const it = authorizedUsers.find((s: any) => s.id === option?.id);
            if (it && !selectedOwner.map((li: any) => li?.id)?.includes(option?.id)) return it?.fullName?.toLowerCase().includes(query?.toLowerCase());
        },
    };

    return <SwitchProvider isDisabled={isSwitchDisabled}>
        <EditModeSwitch addLabel="ADD_OWNER" renderReadOnlyItems={renderReadOnlyItems} isEmpty={selectedOwner?.length === 0} isDisabled={isSwitchDisabled}>
            <GenericTypeahead {...params} />
        </EditModeSwitch>
    </SwitchProvider>
}

const GetSelectedOwner = (item: any, authorizedUsers: any,attributeName:string | undefined) => {
    const userId =attributeName ?  item?.[attributeName] : item.ownerId;
    if (userId === EMPTY_GUID || userId=== "") return [];
    return authorizedUsers?.filter((user: any) => user.id === userId);
};


const Card = styled.div`
display: flex;
align-items: center;
background: var(--color-Grey-Background, #F5F5F5) !important;
border-radius: 4px;
height: 32px;
padding: 2px 8px;
`
export const OwnerName = styled.div`
    color: #333333;
	font-weight: 400;
	font-size: 16px;
	align-self: center;
	margin-left: 0.5rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
    text-transform:  capitalize;
`;